import React from 'react';
import { UpgradeButton } from '@playbookux/playbook-web-core';
import { FlexContainer } from './styles';

const UpgradeButtonProjectApproval = () => (
  <FlexContainer>
    <UpgradeButton
      type="button"
    >
      Upgrade
    </UpgradeButton>
  </FlexContainer>
);

export default UpgradeButtonProjectApproval;
